import { createHtmlElement, ElementAttribute, ElementStyle } from './create-html-element';

export type FrameElementScrolling = 'yes' | 'no';

export const createFrameElement = (url: string, scrolling: FrameElementScrolling = 'no') => {
  const styles: ElementStyle[] = [
    { property: 'border', value: 'none', priority: 'important' },
    { property: 'width', value: '100%', priority: 'important' },
    { property: 'min-width', value: '100%', priority: 'important' },
    { property: 'height', value: '100%', priority: 'important' },
    { property: 'overflow', value: 'hidden', priority: 'important' },
    { property: 'display', value: 'block', priority: 'important' },
    { property: 'user-select', value: 'none', priority: 'important' },
  ];
  const attributes: ElementAttribute[] = [
    { name: 'frameborder', value: '0' },
    { name: 'allowtransparency', value: 'true' },
    { name: 'scrolling', value: scrolling },
    { name: 'allowPaymentRequest', value: 'true' },
  ];
  const frameElement = createHtmlElement('iframe', styles, attributes) as HTMLIFrameElement;
  frameElement.src = url;
  return frameElement;
};
